<button
  class="btn btn-primary btn-project-idea"
  type="submit"
  (click)="goToProjectIdea()"
>
  <span class="fab fa-telegram-plane btn-icon" data-fa-transform="grow-5">
  </span>
  {{ "profile.projects.submitProjectIdea" | translate }}
</button>
